export default __webpack_public_path__ + "static/media/commission.1d09dbfc.svg";